import { jsx as o } from "react/jsx-runtime";
import { withManagedProps as p } from "@made-people/managed-props";
import { z as i } from "zod";
import { withZod as n } from "@made-people/react-prop-guard";
import { ProductProvider as m } from "@made-people/grease-product";
import { productCardPropsSchema as c, ProductCard as d } from "@made-people/blueprint-product-card";
import { swiperPropsSchema as s, Swiper as u } from "@made-people/blueprint-swiper";
import { useSearchResultItems as f } from "@made-people/grease-search";
import { SkeletonCard as b } from "@made-people/blueprint-skeleton-card";
const h = s.extend({
  productCardSettings: c.optional(),
  fallback: i.object({
    enabled: i.boolean().optional(),
    amountOfItems: i.number().optional()
  }).optional()
}), x = p(
  "SwipeableProductList",
  n(
    {
      schema: h,
      defaultProps: {
        fallback: {
          amountOfItems: 12,
          enabled: !0
        }
      }
    },
    (r) => {
      var l;
      const e = f();
      return e && e.length === 0 ? null : /* @__PURE__ */ o(u, { ...r, settings: r.settings, children: e ? e.map((t, a) => /* @__PURE__ */ o("div", { children: t.type === "product" ? /* @__PURE__ */ o(
        m,
        {
          product: t.product,
          context: {
            type: "plp",
            listId: "swipeable-product-list",
            listName: "Swipeable Product List",
            position: a
          },
          children: /* @__PURE__ */ o(d, { ...r.productCardSettings })
        }
      ) : t.type === "component" ? t.data : null }, `product-${a}`)) : Array.from(
        { length: ((l = r.fallback) == null ? void 0 : l.amountOfItems) ?? 12 },
        (t, a) => /* @__PURE__ */ o(b, {}, `skeleton-${a}`)
      ) });
    }
  )
);
export {
  x as SwipeableProductList,
  h as swipeableProductListSchema
};
//# sourceMappingURL=index.es.js.map
